import React from 'react';
import TextInput from '../../../../components/text-input/TextInput';

export default (props) => {
    const {
        key,
        value,
        forcedValue,
        data,
        rules,
        options,
        disabled,
        ruleRequired,
        isRequired,
        onChange
    } = props;

    return <TextInput
        onChange={onChange}
        defaultValue={value}
        value={forcedValue}
        disabled={disabled}
        maxLength={rules.maxLength}
        multipleLines={options.multipleLines}
        numberOfRows={options.numberOfRows}
        appearance={options.appearance || 'lined'}
        placeholder={options.prompt || options.placeholder}
        style={options.style}
        passwordCanShow={options.passwordCanShow}
        trimmed={options.trimmed !== undefined ? options.trimmed : true}
    />;
}
